import { NgComponentOutlet } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Type,
  input,
  inject,
  InputSignal,
  output,
  OutputEmitterRef,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Subject } from "rxjs";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

export interface DialogData {
  title?: string;
  subtitle?: string;
  component: Type<unknown>;
}

@Component({
  selector: "app-custom-dialog",
  imports: [NgComponentOutlet, SvgIconComponent],
  templateUrl: "./custom-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: "./custom-dialog.component.scss",
})
export class CustomDialogComponent implements OnInit, OnDestroy {
  public readonly hideCloseButton: InputSignal<boolean> = input<boolean>(false);
  // Stays @Input(): injecting children write `data` (futures-crypto-payout, futures-revolut-payout).
  @Input() public data?: DialogData;
  // Stays @Input(): injecting children read `validatedData` through the injected dialog instance.
  @Input() public validatedData: unknown;
  public readonly width: InputSignal<string> = input<string>("400px");
  public readonly forceWidth: InputSignal<boolean> = input<boolean>(false);
  public readonly noPadding: InputSignal<boolean> = input<boolean>(false);
  public readonly showSeperator: InputSignal<boolean> = input<boolean>(false);
  public readonly dialogClose: OutputEmitterRef<unknown> = output<unknown>();
  public readonly innerEvent: OutputEmitterRef<unknown> = output<unknown>();

  public innerEvent$: Subject<unknown> = new Subject<unknown>();

  private readonly _el: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly _destroyRef: DestroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    document.body.appendChild(this._el.nativeElement);
    this.innerEvent$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((data: unknown) => {
      this.innerEvent.emit(data);
    });
  }

  public ngOnDestroy(): void {
    if (document.body.contains(this._el.nativeElement)) {
      document.body.removeChild(this._el.nativeElement);
    }
  }

  public close(result?: unknown): void {
    this.dialogClose.emit(result);
  }
}
